var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9898 1.13797C14.3692 0.678081 16.9385 1.36791 18.7881 3.20744C21.7373 6.1567 21.7373 10.9655 18.7881 13.9048C16.7286 15.9543 13.7793 16.5841 11.19 15.7743L6.4812 20.4731C6.14129 20.823 5.47146 21.033 4.99158 20.963L2.81213 20.6631C2.09231 20.5631 1.42248 19.8833 1.31251 19.1634L1.01258 16.984C0.942602 16.5041 1.17254 15.8343 1.50246 15.4944L2.62218 14.3747L6.19127 10.8056C5.39148 8.20618 6.01132 5.25692 8.0708 3.20744",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8916 16.4741L8.19102 18.7735",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4986 9.98557C14.3268 9.98557 14.9983 9.31414 14.9983 8.48595C14.9983 7.65773 14.3268 6.98633 13.4986 6.98633C12.6705 6.98633 11.999 7.65773 11.999 8.48595C11.999 9.31414 12.6705 9.98557 13.4986 9.98557Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenant);
export default __webpack_public_path__ + "static/media/tenant.1d8e8f08eaee1e6346ada9a32717244a.svg";
export { ForwardRef as ReactComponent };